import styled from 'styled-components';

export const StyledButtonWrapper = styled.div`
  width: 20%;
  min-height: 1px;
  position: relative;
  padding-right: 15px;
  /* Mobile Devices */
  @media (max-width: 480px) {
    width: 100%;
    padding-left: 0;
    margin-top: 10px;
  }
  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  /* Mobile Devices */
  @media (max-width: 480px) {
    margin-bottom: 10px;
  }
`;

export const StyledWrapper = styled.div`
  /* Mobile Devices */
  @media (max-width: 480px) {
    width: 98%;
    margin-left: 1%;
    overflow: hidden;
  }
`;
